import React, { useState } from "react";
import "../../styles/components/ScheduleCheck.css";
import moment from "moment";
import helper from "../../utils/helper";
import _ from 'lodash'
import BButton from "../../components/general/BButton";
import { useNavigate } from "react-router-dom";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ScheduleConfirm from "./ScheduleConfirm";

// helper.CONFIG.MONTH()
const ScheduleCheck = ({ currentDate, checkList = [], confirmShift ,onChange }) => {

  const MapSchedule = (s) => {
    const maps = { "1" : "กะเช้า", "2": "กะกลางวัน", "3": "กะดึก" };
    return maps[s] ? maps[s] : null;
  };

  const changeValue = (e, index) => {
    let tmp = _.cloneDeep(checkList)
    console.log(e.target.checked,'index >>', index);
    tmp[index].value = e.target.checked
    console.log('tmp >>', tmp)
    onChange(tmp)
  }
  const onConfirmShift = (checklist = []) => {
    // console.log('checklist >>', checklist)
    const selectValues = checklist.filter(item => item.value)
    confirmShift(selectValues)
    // console.log()
  }
  return (
    <div className="schedule-check-box">
      <div className="schedule-check">
        { checkList.length
        ? 
        <main>
          <h3>คุณต้องการทำงานในช่วงเวลาใด ?</h3>
          <ul>
            { 
              checkList.map((item, index) => (
                <li key={index} >
                  <div className="checkboox">
                    <Checkbox
                      sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                      checked={item.value}
                      onChange={e => changeValue(e, index)}
                      disabled={item.selected}
                    />
                  </div>
                  <div className="info">
                    <div>{ MapSchedule(item.dataSelect?.shift) } { moment(item.dataSelect?.shiftTimeFrom,'HH:mm:ss').format('HH:mm') } - { moment(item.dataSelect?.shiftTimeTo,'HH:mm:ss').format('HH:mm') }</div>
                    { item.selected && <p>คุณได้ทำการจองช่วงเวลานี้แล้ว</p> }
                  </div>
                </li>
              ))
            }
          </ul>
        </main>
        :
        <main className="no-schedule">
          <div className="no-schedule-day">
            <div className="icon">
              <svg width="45" height="51" viewBox="0 0 45 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M43.7946 15.9375H1.20536C0.542411 15.9375 0 15.3996 0 14.7422V11.1562C0 8.5166 2.1596 6.375 4.82143 6.375H9.64286V1.19531C9.64286 0.537891 10.1853 0 10.8482 0H14.8661C15.529 0 16.0714 0.537891 16.0714 1.19531V6.375H28.9286V1.19531C28.9286 0.537891 29.471 0 30.1339 0H34.1518C34.8147 0 35.3571 0.537891 35.3571 1.19531V6.375H40.1786C42.8404 6.375 45 8.5166 45 11.1562V14.7422C45 15.3996 44.4576 15.9375 43.7946 15.9375ZM1.20536 19.125H43.7946C44.4576 19.125 45 19.6629 45 20.3203V46.2188C45 48.8584 42.8404 51 40.1786 51H4.82143C2.1596 51 0 48.8584 0 46.2188V20.3203C0 19.6629 0.542411 19.125 1.20536 19.125ZM27.0502 35.0625L31.8817 30.2713C32.3538 29.8031 32.3538 29.0461 31.8817 28.5779L29.0391 25.759C28.567 25.2908 27.8036 25.2908 27.3315 25.759L22.5 30.5502L17.6685 25.759C17.1964 25.2908 16.433 25.2908 15.9609 25.759L13.1183 28.5779C12.6462 29.0461 12.6462 29.8031 13.1183 30.2713L17.9498 35.0625L13.1183 39.8537C12.6462 40.3219 12.6462 41.0789 13.1183 41.5471L15.9609 44.366C16.433 44.8342 17.1964 44.8342 17.6685 44.366L22.5 39.5748L27.3315 44.366C27.8036 44.8342 28.567 44.8342 29.0391 44.366L31.8817 41.5471C32.3538 41.0789 32.3538 40.3219 31.8817 39.8537L27.0502 35.0625Z" fill="#8F8F8F"/>
              </svg>
            </div>
            <h2>ไม่มีกะทำงานในวันนี้</h2>
          </div>
        </main>
        }
        <div className="s-book-footer">
        { checkList.length ? <ScheduleConfirm currentDate={currentDate} checkList={checkList} onOK={() => onConfirmShift(checkList)}/> : <></> }
        </div>
      </div>
    </div>
  );
};
export default ScheduleCheck;
